import type { WeaponId } from '../core/types';
import { WEAPON_IDS } from '../game/build';
import { OFFER_META } from '../game/offer-meta';

/** 开局初始武器选择浮层（玩家策略选择，不消耗 RNG 流）。 */
export class WeaponPick {
  constructor(
    private screen: HTMLElement,
    private cards: HTMLElement,
  ) {}

  show(onPick: (w: WeaponId) => void): void {
    this.cards.textContent = '';
    for (const id of WEAPON_IDS) {
      const meta = OFFER_META[id];
      const btn = document.createElement('button');
      btn.className = 'upgrade-card';
      btn.innerHTML =
        '<span class="upgrade-tag">初始武器</span>' +
        `<span class="upgrade-name">${meta.name}</span>` +
        `<span class="upgrade-desc">${meta.desc}</span>`;
      btn.addEventListener('click', () => onPick(id));
      this.cards.appendChild(btn);
    }
    this.screen.classList.remove('hidden');
  }

  hide(): void {
    this.screen.classList.add('hidden');
  }
}
